var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogledocs = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 70.48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4285f4;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: #a1c2fa;\n      }\n\n      .cls-4 {\n        fill: #f1f1f1;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exntensionBack"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m32.04,0H4.8C2.24,0,0,2.24,0,4.81v60.87c0,2.56,2.24,4.81,4.81,4.81h41.65c2.56,0,4.81-2.24,4.81-4.81V19.22l-11.21-8.01L32.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m12.81,51.26h25.63v-3.2H12.82v3.2h0Zm0,6.41h19.22v-3.2H12.81v3.2Zm0-22.43v3.2h25.63v-3.2H12.81Zm0,9.61h25.63v-3.2H12.82v3.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m32.04,0v14.42c0,2.56,2.24,4.8,4.8,4.8h14.42L32.04,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m80.18,53.71V16.1h13.42c11.73,0,19.51,8.01,19.51,18.83s-7.78,18.77-19.51,18.77h-13.42Zm5.64-4.96h7.78c8.68,0,13.7-6.2,13.7-13.81s-4.85-13.87-13.7-13.87h-7.78v27.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m118.13,40.06c0-7.84,5.3-14.26,13.76-14.26s13.76,6.43,13.76,14.26-5.24,14.32-13.76,14.32-13.76-6.43-13.76-14.32Zm22.21,0c0-5.13-2.99-9.75-8.46-9.75s-8.46,4.62-8.46,9.75,3.04,9.81,8.46,9.81,8.46-4.62,8.46-9.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m164.25,25.8c5.13,0,8.23,2.14,10.2,4.79l-3.38,3.1c-1.64-2.31-3.83-3.38-6.6-3.38-5.36,0-8.79,4.12-8.79,9.75s3.44,9.81,8.79,9.81c2.76,0,4.96-1.13,6.6-3.38l3.38,3.1c-1.97,2.65-5.07,4.79-10.2,4.79-8.23,0-13.87-6.14-13.87-14.32s5.64-14.26,13.87-14.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m180.1,46.43c1.86,2.03,5.47,3.89,9.13,3.89s5.86-1.58,5.86-3.89c0-2.71-3.1-3.61-6.6-4.4-4.62-1.07-10.04-2.31-10.04-8.18,0-4.34,3.72-8.06,10.37-8.06,4.68,0,8.06,1.69,10.37,3.89l-2.25,3.55c-1.58-1.92-4.62-3.33-8.06-3.33s-5.58,1.35-5.58,3.55c0,2.37,2.93,3.16,6.31,3.95,4.74,1.07,10.37,2.37,10.37,8.62,0,4.68-3.83,8.34-10.99,8.34-4.57,0-8.57-1.41-11.33-4.23l2.42-3.72Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogledocs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/googledocs.050984493e7a58c8dbb8329df864eab9.svg";